import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { from, Observable } from 'rxjs';

@Injectable()
export class NavigationService {
  constructor(private router: Router, private location: Location) {}

  //#region Getters

  get routePrefix(): string {
    const currentRoute = this.location.path();
    const splitUrl = currentRoute.split('/');

    if (!currentRoute || splitUrl.length < 1) {
      return null;
    }

    const clientId = splitUrl[1];

    return clientId;
  }

  //#endregion

  navigateToRoute(...routeSegments: string[]): void {
    this.router.navigate(this.buildRoute(...routeSegments));
  }

  navigateToRouteWithReplaceAsync(
    ...routeSegments: string[]
  ): Observable<boolean> {
    return from(
      this.router.navigate(this.buildRoute(...routeSegments), {
        replaceUrl: true,
      })
    );
  }

  getSubRoute(redirectState: string, previousRoute: string): string {
    let splitRoute: string[];

    switch (redirectState) {
      case 'project-setup':
        splitRoute = previousRoute?.includes('project-setup')
          ? previousRoute.split('/')
          : null;
        return splitRoute && splitRoute.length > 3 ? splitRoute[4] : '';
      case 'project-admin':
        splitRoute = previousRoute?.includes('project-admin')
          ? previousRoute.split('/')
          : null;
        return splitRoute && splitRoute.length > 2 ? splitRoute[3] : '';
      default:
        return '';
    }
  }

  goToNoAccessErrorRouteAsync(): Observable<boolean> {
    return from(
      this.router.navigate(['/error'], {
        queryParams: {
          errorType: 'no-access-rights',
        },
      })
    );
  }

  //#region Private methods

  private buildRoute(...values: string[]): string[] {
    return ['/', ...values.filter((x) => !String.isNullOrWhiteSpace(x))];
  }

  //#endregion
}
